import { isFinite } from 'lodash'

import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { round } from 'utils/math'
import { ReactElement } from 'react'
import { IFormattedDistanceProps } from './types'

export const FormattedDistance = ({ distance, decimals = 3 }: IFormattedDistanceProps): ReactElement => {
  if (!isFinite(distance)) return <span>-</span>

  return <FormattedNumber value={round(distance / 1000, decimals)} suffix=" km" />
}
